<template>
	<v-dialog v-model="visible" :max-width="maxWidth" persistent>
		<v-card
			color="#FFFFFF"
		>
			<v-system-bar :color="color" height="12"></v-system-bar>
			<v-alert v-if="error_msg.length !== 0" class="my-1 rounded-b-0" type="error" dense>
				{{ error_msg }}
			</v-alert>
			<div class="pa-4">
				<v-row class="ma-0">
					<span class="title-sytle">Phase information</span>
				</v-row>
				<v-row class="ma-0">
					<v-col cols="6" class="pl-0 pr-2">
						<div class="item-style">Phase name (formerly description)</div>
						<v-text-field
							v-model="phase_name"
							:color="color"
							outlined
							dense
							hide-details
							background-color="#FAFAFA"
						></v-text-field>
						<div class="item-style mt-7">Start date to End date</div>
						<DateMulti
							:startText="'DD Mmm YYYY'"
							:endText="'DD Mmm YYYY'"
							:suggestionText="''"
							:color="color"
							:background="`#FAFAFA`"
						/>
						<div class="item-style">Deadline</div>
						<DatePicker
							:isOutlined="true"
							:isIcon="true"
							:suggestionText="''"
							:placeholder="'DD Mmm YYYY'"
							:color="color"
							:background="`#FAFAFA`"
						/>
					</v-col>
					<v-col cols="6" class="pl-2 pr-0">
						<div class="item-style">Status</div>
						<v-select
							v-model="status_select"
							:items="status_items"
							:color="color"
							:item-color="color"
							:menu-props="{ bottom: true, offsetY: true}"
							background-color="#FAFAFA"
							outlined
							dense
							hide-details
						>
						</v-select>
						<div class="item-style mt-7">Remark</div>
						<v-textarea
							:color="color"
							outlined
							:value="remark"
							hide-details
							clearable
							height="126"
							background-color="#FAFAFA"
						></v-textarea>
					</v-col>
				</v-row>
				<v-row class="ma-0" justify="center">
					<v-btn outlined class="text-capitalize mr-2" color="rgba(25, 42, 62, 0.7)" max-height="36" @click="$emit('close')">Cancel</v-btn>
					<v-btn class="text-capitalize white--text" :color="color" elevation="0" @click="onSave()">Save changes</v-btn>
				</v-row>
			</div>
		</v-card>
	</v-dialog>
</template>
<script>
import DateMulti from "@/components/date/date_multi.vue";
import DatePicker from "@/components/date/date_picker.vue";

export default {
	name: 'MediaPlanPhaseDialog',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		maxWidth: {
			type: Number,
			default: 600
		},
		color: {
			type: String,
			default: '#605AF6'
		}
	},
	components: {
		DateMulti,
		DatePicker
	},
	data() {
		return {
			error_msg: '',
			phase_name: 'Phase 1',
			status_select: 'Active',
			status_items: ['Active'],
			remark: 'remark'
		}
	},
	watch: {
		
	},
	computed: {
		
	},
	methods: {
		onSave() {
			const obj = {};
			this.$emit('update', obj);
		}
	}
}
</script>
<style lang="scss" scoped>
.title-sytle {
  font-family: Roboto;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #605AF6;
}
.item-style {
  font-family: Roboto;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #37495F;
}
</style>